import React from 'react';
import useSetExport from '@components/export/useSetExport';
import { getMetricDisplayName } from '@src/utils/metrics';

function useSetDistributionExport({ metric, data = [] }) {
  const metricName = getMetricDisplayName({ metricKey: metric });

  const headers: any = [
    {
      key: 'buckets',
      title: 'Buckets',
    },
    {
      key: metric,
      title: metricName,
    },
  ];

  useSetExport({
    pageKey: 'trends',
    sectionKey: 'metrics-panel',
    widgetKey: `distribution::${metric}`,
    headers,
    data,
    widgetInfo: {
      title: `${metricName} Distribution`,
    },
  });
}

export default useSetDistributionExport;
